// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3153) return "static/chunks/3153-d86e7d648f3f2f41.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4980":"fb9cd874f4b97c4f","6850":"43c5ac3be5e1eddb"}[chunkId] + ".js";
};